import { useState, useCallback, useMemo } from 'react'

export interface UseModal {
  isOpened: boolean
  close: () => void
  open: () => void
  set: (value: boolean) => void
}

export default function useNewModal(initialIsOpened = false): UseModal {
  const [isOpened, setIsOpened] = useState(initialIsOpened)

  const close = useCallback(() => setIsOpened(false), [])

  const open = useCallback(() => setIsOpened(true), [])

  return useMemo<UseModal>(
    () => ({
      isOpened,
      close,
      open,
      set: setIsOpened
    }),
    [close, isOpened, open]
  )
}
